export default "__VITE_ASSET__DwBOCnCh__"